"use strict";
exports.__esModule = true;
exports["default"] = void 0;
var tslib_1 = require("tslib");
var Twitter_1 = require("./Twitter");
(0, tslib_1.__createBinding)(exports, Twitter_1, "default");
(0, tslib_1.__exportStar)(require("./Twitter"), exports);
//# sourceMappingURL=index.js.map